// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1COSh","productName":"Table_productName__1kQsV"};